import { IReportsRepository } from "../../repositories/reports_repository";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { IGetReportFuncionariosUseCase } from "../../../presentation/useCases/read/get_report_funcionarios_use_case";
import { RangedDate } from "../../../../../common/utils/ranged_date_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { ReportData } from "../../models/report_data";

import dayjs from "dayjs";

/**
 * GetReportFuncionariosUseCase
 */

export class GetReportFuncionariosUseCase implements IGetReportFuncionariosUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportFuncionarios(
    requiredMimeType: ReportMimeType | null,
    idUsuario: number,
    setor: string[] | null,
    filial: string[] | null,
    status: number[] | null,
    nome: number[] | null,
    centroCusto: number[] | null,
    dataAdmissao: RangedDate,
    dataDemissao: RangedDate,
    dataFerias: RangedDate,
  ): Promise<ReportData> {
    const response = await this.repository.getReportFuncionarios(
      requiredMimeType,
      idUsuario,
      nome,
      status?.length === 2 ? [...status, 2] : status,
      setor,
      filial,
      centroCusto,
      dataAdmissao.dataDe,
      dataAdmissao.dataAte,
      dataDemissao.dataDe,
      dataDemissao.dataAte,
      dataFerias.dataDe,
      dataFerias.dataAte,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `funcionarios_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }

    return response;
  }
}
